export default __webpack_public_path__ + "de4b83edce7d813eedeace14546f527b.png";